<template>
  <znl-dialog
    :visible="visible"
    :append-to-body="true"
    title="常见问题"
    width="760px"
    class="c-CommonProblems"
    @close="$emit('update:visible', false)"
  >
    <div>
      <h4>
        我该如何处理订单？
      </h4>
      <el-row>
        根据订单要求将物料送到正能量QC中心。
      </el-row>
      <el-row>
        业务联系人：袁小姐
      </el-row>
      <el-row>
        联系电话：0755-82798001
      </el-row>
      <el-row>
        正能量QC中心地址：深圳市福田区华强北街道荔村社区华强北路2006号桑达418栋4层（曼哈双创中心）A39室
      </el-row>

      <h4>
        发货包装有什么要求？
      </h4>
      <el-row>
        1、请尽量使用静电袋包装。
      </el-row>
      <el-row>
        2、请尽量在静电袋贴上标签，标签应包含以下内容：型号<span class="color-red">*</span>、数量<span class="color-red">*</span>、品牌<span class="color-red">*</span>、封装<span class="color-red">*</span>、批号、产地。
      </el-row>

      <h4>
        送货单有什么要求吗？
      </h4>
      <el-row>
        送货单向正能量开具，一式两份，回签给供应商一份，正能量留存一份；应包含以下内容：型号、品牌、封装、批号、产地、数量、单价、总价、公司名称。
      </el-row>

      <h4>
        发货时间有什么要求吗？
      </h4>
      <el-row>
        1、中午12:00前产生的订单，请在当天下午送货到正能量。
      </el-row>
      <el-row>
        2、中午12:00后产生的订单，请在次日上午送货到正能量。
      </el-row>

    </div>
    <div slot="footer">
      <znl-button
        :width="80"
        :height="30"
        @click="showQQ"
      >联系客服</znl-button>
      <znl-button
        :width="80"
        :height="30"
        style-type="main"
        class="fml"
        @click="$emit('update:visible', false)"
      >好的</znl-button>
    </div>
  </znl-dialog>
</template>
<script>
export default {
  props: {
    visible: Boolean
  },
  methods: {
    showQQ() {
      window.open(
        'http://wpa.qq.com/msgrd?v=3&uin=800106568&site=qq&menu=yes',
        '_brank'
      );
    }
  }
};
</script>
<style lang="scss">
.c-CommonProblems {
  .znl-dialog__body {
    padding-top: 0;
  }
  .fml {
    margin-left: 10px;
  }
  h4 {
    margin: 5px 0;
  }
  .el-row {
    font-size: 12px;
  }
  .color-red {
    color: red;
    font-weight: 900;
  }
}
</style>


